<template>
  <a-drawer :title="`${pipelineId ? '编辑' : '创建'}流水线`" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" :visible="visible" :width="900" @close="onCancel">
    <a-form-model ref="form" :model="form" :rules="rules" layout="vertical">
      <a-form-model-item ref="name" label="模板" prop="template_id">
        <a-radio-group v-model="form.template_id" style="width: 100%" @change="onChange">
          <a-card v-for="template in templateList" :key="template.id" size="small" class="pipeline-template">
            <a-radio :value="template.id">
              <span class="pipeline-template_title">{{ template.name }}</span>
            </a-radio>
            <a-steps size="small" class="pipeline-template_step">
              <a-step v-for="(stage, index) in template.stages" :key="index" status="process" :title="stage.name" />
            </a-steps>
          </a-card>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item ref="name" label="流水线名称" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="关联服务" prop="service_id">
        <a-select v-model="form.service_id" placeholder="请选择服务" @focus="getServiceList" @change="onChangeService">
          <a-select-option v-for="service in serviceListData" :key="service.service_id" :value="service.service_id">
            <a-tag v-if="service.service_type" :color="service.service_type.color" size="small">{{ service.service_type.label }}</a-tag>
            {{ service.service_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="默认分支" prop="default_branch">
        <a-select v-model="form.default_branch" placeholder="请选择默认分支" :disabled="edit" :filter-option="false" :show-search="true" @search="getBranchList" @focus="getBranchList">
          <a-select-option v-for="(branch, index) in branchList" :key="index" :value="branch.name"> {{ branch.name }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="消息通知群聊" prop="chat_ids">
        <chat-select v-model="form.chat_ids" />
      </a-form-model-item>

      <a-form-model-item label="Sonar项目名" prop="sonar_project">
        <a-input v-model="form.sonar_project" :disabled="edit" />
      </a-form-model-item>
      <a-form-model-item label="构建脚本" prop="build_script">
        <code-mirror-component v-model="form.build_script" language="shell" />
      </a-form-model-item>
      <a-form-model-item label="DockerFile" prop="dockerfile">
        <code-mirror-component v-model="form.dockerfile" language="dockerfile" />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1
      }"
    >
      <a-button :style="{ marginRight: '8px' }" @click="onClose"> 取消 </a-button>
      <a-button type="primary" @click="onSubmit"> 提交 </a-button>
    </div>
  </a-drawer>
</template>

<script>
import ChatSelect from '@/components/FeiShu/ChatSelect';
import CodeMirrorComponent from '@/components/CodeMirrorComponent';

import { serviceList, serviceDetail, gitlabBranchList } from '@/api/system/service';
import { pipelineAdd, pipelineModify, pipelineDetail, pipelineTemplateList } from '@/api/project/pipeline';

export default {
  name: 'PipelineDrawer',
  components: { ChatSelect, CodeMirrorComponent },
  props: {
    pipelineId: {
      type: [String, Number],
      default: null
    },
    serviceId: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      current: 0,
      form: {
        template_id: null,
        service_id: null
      },
      projectId: parseInt(this.$route.params.project_id) || null,
      rules: {
        name: [{ required: true, message: '流水线名称不能为空', trigger: 'blur' }],
        service_id: [{ required: true, message: '关联服务不能为空', trigger: 'blur' }],
        default_branch: [{ required: true, message: '默认分支不能为空', trigger: 'blur' }],
        sonar_project: [{ required: true, message: 'Sonar项目名不能为空', trigger: 'blur' }],
        build_script: [{ required: true, message: '构建脚本不能为空', trigger: 'blur' }],
        dockerfile: [{ required: true, message: 'DockerFile不能为空', trigger: 'blur' }],
        chat_ids: [{ required: true, message: '消息推送群聊不能为空', trigger: 'blur' }],
        template_id: [{ required: true, message: '流水线模板不能为空', trigger: 'blur' }]
      },
      serviceListData: [],
      branchList: [],
      templateList: []
    };
  },
  computed: {
    edit() {
      return this.form.service_id === null;
    }
  },
  watch: {
    visible() {
      if (this.visible === true) {
        this.getPipelineTemplate();
        if (this.pipelineId !== null) {
          this.getPipelineDetail();
        }
      } else {
        this.form = {};
      }
    }
  },
  methods: {
    onClose() {
      this.$refs.form.resetFields();
      this.loading = false;
      this.$emit('close');
    },
    onCancel() {
      this.utils.trackClick({ name: '取消编辑' });
      this.onClose();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getServiceList() {
      serviceList({}).then(response => {
        this.serviceListData = response.data.services;
      });
    },

    getPipelineTemplate() {
      pipelineTemplateList({}).then(response => {
        this.templateList = response.data.templates;
      });
    },

    getPipelineDetail() {
      pipelineDetail({ pipeline_id: this.pipelineId, project_id: this.projectId }).then(response => {
        const data = response.data;
        this.form = {
          git_id: data.custom_params.git_id,
          template_id: data.template_id,
          name: data.name,
          default_branch: data.default_branch,
          service_id: data.service_id,
          sonar_project: data.custom_params.sonar_project,
          build_script: data.custom_params.build_script,
          chat_ids: data.chat_ids,
          dockerfile: data.custom_params.dockerfile
        };
        this.getBranchList();
        this.getServiceList();
      });
    },

    onChangeService() {
      this.branchList = [];
      this.form.default_branch = null;
      serviceDetail({ service_id: this.form.service_id }).then(response => {
        const data = response.data;
        this.form = {
          ...this.form,
          git_id: data.git_id,
          sonar_project: data.sonar_name,
          build_script: data.build_script,
          dockerfile: data.dockerfile
        };
      });
    },
    getBranchList(value = null) {
      gitlabBranchList({ git_id: this.form.git_id, search: value }).then(response => {
        this.branchList = response.data.branch_list;
      });
    },

    onSubmit() {
      this.utils.trackClick({ name: '提交编辑' });
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            name: this.form.name,
            project_id: this.projectId,
            template_id: this.form.template_id,
            chat_ids: this.form.chat_ids,
            service_id: this.form.service_id,
            default_branch: this.form.default_branch,
            custom_params: {
              git_id: this.form.git_id,
              sonar_project: this.form.sonar_project,
              build_script: this.form.build_script,
              dockerfile: this.form.dockerfile
            }
          };
          this.loading = true;
          if (this.pipelineId) {
            pipelineModify({ ...params, pipeline_id: this.pipelineId })
              .then(() => {
                this.$message.success('流水线修改成功');
                this.onClose();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            pipelineAdd(params)
              .then(() => {
                this.$message.success('流水线创建成功');
                this.onClose();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    onChange() {
      // onChange
    }
  }
};
</script>

<style lang="less" scoped>
.pipeline-template {
  margin-bottom: 8px;
  .pipeline-template_title {
    font-size: 14px;
    font-weight: bold;
  }
  .pipeline-template_step {
    margin-top: 8px;
  }
}
</style>
